import PropTypes from 'prop-types'

import { usageMetadataPropType } from '@/utils/normalization'

export { usageMetadataPropType }

/**
 * The project currently ships as JavaScript/JSX, so we centralize prop shape
 * definitions using JSDoc + PropTypes instead of TypeScript interfaces. This
 * keeps consumer components aligned and makes a future TS migration easier.
 */

/**
 * @typedef {Object} UsageMetadata
 * @property {number|null} limit - Daily free questions allowed.
 * @property {number|null} remaining - Questions still available in the current window.
 * @property {string|null} resetAt - Timestamp (ISO string) when quota resets.
 */

export const usageIndicatorPropTypes = {
  usageMetadata: usageMetadataPropType.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  showLegend: PropTypes.bool,
  className: PropTypes.string,
  legendText: PropTypes.string,
}

export const usageIndicatorDefaultProps = {
  size: 'md',
  showLegend: true,
  className: '',
}

export const usageIndicatorTypeHelpers = {
  usageMetadataPropType,
  usageIndicatorPropTypes,
  usageIndicatorDefaultProps,
}

export default usageIndicatorTypeHelpers
